export default {
  'app.pwa.offline': 'Şu anda çevrimdışısınız',
  'app.pwa.serviceworker.updated': 'Yeni içerik mevcut',
  'app.pwa.serviceworker.updated.hint': 'Lütfen mevcut sayfayı yeniden yüklemek için "Yenile" düğmesine basın',
  'app.pwa.serviceworker.updated.ok': 'Yenile',
  'app.serviceOffline': 'Şu anda çevrimdışısınız',
};
